<template>
    <b-dropdown :text=selectedChannelName>
        <b-dropdown-item v-for="channel in channels" :key="channel.id"  v-on:click="channelSelected(channel)">{{channel.name}}</b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { distributionChannelService } from "../../shared/services";
export default {
    computed: {
        loginState : function() {
            return globalStore.loginState;
        },
        selectedChannelName : function() {
            if(this.selectedChannel) return this.selectedChannel.name
            return "Välj mottagare";
        }
    },
    data: function() {
        return {
            selectedChannel: null,
            channels: [],
        };
    },
    methods: {
        channelSelected(channel) {
            this.selectedChannel = channel;
            this.$emit("onChannelSelected", channel);
        },
        loaded() {
            this.selectedChannel = null;
        }
    },

    mounted () {
        distributionChannelService.getAll().then(p => {
            this.channels = p;
            }).catch(() => this.ShowToast("Fel", "Ett okänt fel uppstod när distributionskanaler skulle hämtas", "danger"));

    }
}
</script>

<style>

</style>
